<template lang="pug">
    v-dialog.modal(v-model="showMe" width="600" @keydown.escape="showMe = false" @keydown.enter="handle($event)")
        v-toolbar.title.font-weight-bold(:color="color" dark)
            |   Requiere Autorización del Supervisor
        v-card
            v-container     
                v-layout(row wrap)
                    v-flex(xs12).mb-4
                        slot(name="content")
                    v-flex(xs12).mb-4.input-container
                        span SUPERVISOR
                        v-form(ref="form")
                            v-text-field.text-xs-center.password-input.display-1(
                                ref="authcode" 
                                :rules="rules" 
                                mask="A###########" 
                                v-model="code" 
                                outline 
                                full-width 
                                maxlength="12" 
                                type="password"
                                @blur="showMe ? handleFocus('authcode'): ''"
                            ) 
                    v-flex(xs6).px-3
                        v-btn(color="success" @click="handleSubmit()" block large) Autorizar
                    v-flex(xs6).px-3
                        v-btn(ref="authbutton" color="warning" @click="showMe = false" block outline large) Cancelar
</template>

<script>
import InputValidation from '@/mixins/InputValidations.js'
import { mapActions } from 'vuex'
import BarcodeScannerHandler from '@/components/BarcodeScannerHandler/BarcodeScannerHandler'
export default {
    name: 'auth-modal',
    props: {
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        color: {
            type: String,
            default: () => 'primary',
        },
    },
    data: function() {
        return {
            code: '',
            rules: [
                value =>
                    value.length < 12 ? 'debe ingresar 12 caractéres' : true,
            ],
        }
    },
    computed: {
        showMe: {
            get: function() {
                return this.value
            },
            set: function(boolean) {
                this.$emit('input', boolean)
            },
        },
    },
    methods: {
        handleSubmit: function() {
            this.$emit('submit:clicked')
            if (!this.$refs.form.validate()) return this.handleFocus('authcode')
            this.$emit('submit', this.code)
        },
        handleFocus: function(ref) {
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handle: function(e) {
            e.preventDefault()
            e.stopPropagation()
            this.handleSubmit()
        },
        ...mapActions('TransactionModule', {
            toggleAuthMode: 'toggleAuthMode',
        }),
    },
    watch: {
        /**
         * @description
         */
        value: function(newVal, oldVal) {
            this.toggleAuthMode(newVal)
            if (newVal === true) {
                this.handleFocus('authcode')
            }
            if (newVal) {
                this.handleFocus('authcode')
            }
        },
        // code: function(){
        //     if(this.code.length === 12) this.handleSubmit()
        // }
    },
    components: {
        'barcode-scanner-handler': BarcodeScannerHandler,
    },
    mixins: [InputValidation],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // beforeMount: function(){...},
    beforeUpdate: function() {
        if (!this.value) this.code = ''
    },
    // updated: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.password-input {
    overflow: hidden;
    max-width: 120px;
    min-width: 140px;
    max-height: 100px;
}
.input-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>
